import { useState } from "react";

export default function ComparisonTable({ quotes }) {
  const [system, setSystem] = useState("Imperial");
  const visibleQuotes = quotes.filter(q => q.hse_approved);

  if (visibleQuotes.length === 0) {
    return (
      <div className="tray-inset p-6 text-center" data-testid="comparison-empty">
        <div className="font-mono-data text-xs text-text-secondary tracking-widest uppercase">
          Approve HSE scores above to reveal apples-to-apples comparison
        </div>
      </div>
    );
  }

  const isMetric = system === "Metric";

  return (
    <div className="tray-inset p-5" data-testid="comparison-table">
      <div className="flex items-center justify-between mb-5">
        <div>
          <div className="font-mono-data text-[10px] tracking-[0.3em] uppercase text-text-secondary">Normalized Comparison</div>
          <div className="font-display text-2xl mt-1">Apples to Apples</div>
        </div>
        <div className="flex items-center gap-3">
          <span className={`font-mono-data text-xs ${!isMetric ? "text-amber-500" : "text-text-secondary"}`}>IMPERIAL</span>
          <button
            data-testid="unit-toggle"
            onClick={() => setSystem(isMetric ? "Imperial" : "Metric")}
            className={`skeu-switch ${isMetric ? "on" : ""}`}
          >
            <div className="skeu-switch-thumb" />
          </button>
          <span className={`font-mono-data text-xs ${isMetric ? "text-amber-500" : "text-text-secondary"}`}>METRIC</span>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full font-mono-data text-xs">
          <thead>
            <tr className="border-b border-white/10 text-text-secondary uppercase tracking-widest text-[10px]">
              <th className="text-left py-3 px-2">Vendor</th>
              <th className="text-left py-3 px-2">Origin Units</th>
              <th className="text-right py-3 px-2">Line Items</th>
              <th className="text-right py-3 px-2">Total ({isMetric ? "USD" : "USD"})</th>
              <th className="text-right py-3 px-2">vs. Lowest</th>
            </tr>
          </thead>
          <tbody>
            {visibleQuotes
              .sort((a, b) => (a.total_amount || 0) - (b.total_amount || 0))
              .map((q, i, arr) => {
                const lowest = arr[0]?.total_amount || 1;
                const diff = ((q.total_amount - lowest) / lowest) * 100;
                const total = q.normalized?.grand_total_usd ?? q.total_amount;
                const lines = isMetric ? q.normalized?.metric : q.normalized?.imperial;
                return (
                  <tr key={q.id} className="border-b border-white/5" data-testid={`compare-row-${q.id}`}>
                    <td className="py-3 px-2">
                      <div className="text-white">{q.company}</div>
                      <div className="text-text-secondary text-[10px]">{q.vendor_name}</div>
                    </td>
                    <td className="py-3 px-2 text-text-secondary">{q.unit_system}</td>
                    <td className="text-right py-3 px-2">{(lines || q.line_prices || []).length}</td>
                    <td className="text-right py-3 px-2 text-amber-500 text-sm">${(total || 0).toLocaleString()}</td>
                    <td className={`text-right py-3 px-2 ${i === 0 ? "text-emerald-400" : "text-red-400"}`}>
                      {i === 0 ? "LOWEST" : `+${diff.toFixed(1)}%`}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
